import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "components/LoginButton";
import ProfileDropDown from "components/ProfileDropdown";

const AuthenticationButton = () => {
  const { isAuthenticated } = useAuth0();

  return isAuthenticated ? <ProfileDropDown /> : <LoginButton />;
};

export default AuthenticationButton;
